import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "o-grid__cell o-grid__cell--6-768 o-grid__cell--4-1024" }
const _hoisted_2 = { class: "c-card c-card--fixed-width" }
const _hoisted_3 = { class: "c-card__image-container" }
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "c-card__badge"
}
const _hoisted_10 = { class: "c-card__content-container" }
const _hoisted_11 = { class: "c-card__content-wrapper" }
const _hoisted_12 = { class: "c-card__heading" }
const _hoisted_13 = ["href", "title"]
const _hoisted_14 = { class: "c-card__text" }
const _hoisted_15 = ["href", "title"]
const _hoisted_16 = { class: "u-mar-t-0" }
const _hoisted_17 = { class: "c-card__controls-item" }
const _hoisted_18 = { class: "o-grid o-grid--align-middle o-grid--no-y-gutter" }
const _hoisted_19 = { class: "o-grid__cell c-card__more" }
const _hoisted_20 = ["href", "title"]
const _hoisted_21 = { class: "o-grid__cell u-text-align-right" }
const _hoisted_22 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.link,
          class: "inherited",
          title: _ctx.produktName,
          target: "_self"
        }, [
          _createElementVNode("picture", null, [
            _createElementVNode("source", {
              media: "(max-width: 767px)",
              srcset: _ctx.bildSrc
            }, null, 8, _hoisted_5),
            _createElementVNode("source", {
              media: "(max-width: 1023px)",
              srcset: _ctx.bildSrc
            }, null, 8, _hoisted_6),
            _createElementVNode("source", {
              media: "(min-width: 1024px)",
              srcset: _ctx.bildSrc
            }, null, 8, _hoisted_7),
            _createElementVNode("img", {
              class: "c-card__image",
              src: _ctx.bildLink,
              alt: _ctx.produktName
            }, null, 8, _hoisted_8)
          ]),
          (_ctx.preis)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.preis), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h4", _hoisted_12, [
            _createElementVNode("a", {
              href: _ctx.link,
              class: "inherited",
              title: _ctx.produktName,
              target: "_self"
            }, _toDisplayString(_ctx.produktName.toUpperCase()), 9, _hoisted_13)
          ]),
          _createElementVNode("p", _hoisted_14, [
            _createElementVNode("a", {
              href: _ctx.link,
              class: "inherited",
              title: _ctx.produktName,
              target: "_self"
            }, "Die ganz nach eigenen Bedürfnissen zusammenstellbare Absicherung trägt die Kosten für Reparaturen oder sogar den Wiederaufbau Ihres Gebäudes...", 8, _hoisted_15)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("a", {
                  href: _ctx.link,
                  title: _ctx.mehrAltText,
                  target: "_self"
                }, "Mehr Infos", 8, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("a", {
                  href: _ctx.rechnerLink,
                  role: "button",
                  class: "c-button",
                  title: _ctx.berechnenAltText,
                  target: "_self"
                }, "Jetzt berechnen", 8, _hoisted_22)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}